import { useQuery } from '@tanstack/react-query';
import { fetchBoardDetail, type BoardDetail } from '@/features/class/boardsApi';

/**
 * GET /midl/api/v3/board/<boardId> — full board detail.
 *
 * Used by the edit-class modal to surface the real backend `subject` and
 * `grade` (`{ id, name }`) so the Subject and Year/Grade fields display the
 * class's actual values (e.g. "artificial intelligence" / "Pre-K") instead of
 * rendering blank for boards that aren't part of the seeded manage store.
 *
 * Pass `undefined` to disable the query (e.g. for seeded/mock classes or when
 * the modal is closed).
 */
export function useBoardDetailQuery(boardId: number | string | undefined) {
  return useQuery<BoardDetail | null>({
    queryKey: ['board', 'detail', String(boardId ?? '')],
    queryFn: () => fetchBoardDetail(boardId as number | string),
    enabled: boardId != null && String(boardId).length > 0,
    staleTime: 30_000,
    refetchOnMount: 'always',
  });
}
